import React, {useEffect, useState} from "react";
import LocalStorageDataStorer from "../../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../../dataAccessLayer/localStorage/LocalStorageKey";

export default function ResponseReport(){

    const[_responsesReport, setResponsesReport] = useState([]);


    useEffect(()=>{
        const allResponses = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.allQuestionnaireResponseDataPoints);
        //console.log("ResponseReport-useEffect-allResponses", allResponses);
        if(allResponses){
            setResponsesReport(allResponses);
        }
    },[]);


    return(
        <div className="responses-container">    
            <h1 className="card-label position-rel t-20"> Your Questionnaire Responses</h1>
            <h3> Here you will find the Questions and your answers with their corresponding character Type</h3>
            <ul className="questionnaire-response-list position-rel t-20">
                {_responsesReport.map((question, index)=>(
                     <li key={index} className="flex-column-items-start question-response-card text-left">
                         <span key={question.questionIndex} className="font-s15"> <strong>{question.questionTitle}</strong> </span> 
                         <p key={question.questionResponse.responseText}>{question.questionResponse.responseText}</p>
                         <p key={question.questionResponse.CharacterTypeName} className="response-character-type-name font-s12">{question.questionResponse.CharacterTypeName}</p>
                     </li>
                ))}
            </ul>

            <div className="footer-section">
            <div className="signature-section">
                <span className="font-color-darkblue">To your success</span>
                <span className="signature-text">Robert Kirby</span>
                <span className="font-color-darkblue">Lead Facilitator & Character Type Analyst</span>
            </div>
        </div>
        </div>
    );
}